export enum BlocksAssetType {
  BlockNormal = 'block_normal',
  BlockNormalHighlight = 'block_normal_highlight',
  BlockMultiplier = 'block_multiplier',
  BlockMultiplierHighlight = 'block_multiplier_highlight',
  StartButton = 'start_button',
  PlayIcon = 'play_icon',
}

export enum BlocksSpriteType {
  Placeholder = 'placeholder',
}

export enum BlocksTranslationsType {
  Play = 'play',
  Level = 'level',
}

export enum BlocksStylesType {
  CellAFill = '--game-blocks-cell-a-fill',
  CellBFill = '--game-blocks-cell-b-fill',
  ScoreFill = '--game-blocks-score-fill',
  PrimaryLabelFill = '--game-blocks-primary-label-fill',
  SecondaryLabelFill = '--game-blocks-secondary-label-fill',
  CellPointsLabelFill = '--game-blocks-cell-points-fill',
  StartLabelFill = '--game-blocks-start-fill',
  PointsLabelFill = '--game-blocks-points-fill',
  PointsLabelStroke = '--game-blocks-points-stroke',
  LevelBackgroundFill = '--game-blocks-level-background-fill',
}
